import React, { useEffect, useState } from 'react';

import utils from '../../Helpers/FunctionsHelpers';
import Chart from '../Charts/GoogleChartsCompat';
import OpenedNCsModal from '../Main/OpenedNCsModal';
import SupervisionModal from '../Main/SupervisionModal';

import {
  getCountTratativas,
  getGroupSystemMaintenanceOpen,
  getQuantTratativasOp,
  getSupervisaoMaintenance,
} from '../Api/Api';

export default function Supervision() {
  const currentDate = new Date();
  const [show, setShow] = useState(false);
  const [showListNCs, setShowListNcs] = useState(false);
  const [dataPieNCs, setDataPieNCs] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleClose = () => setShow(false);
  const handleCloseListNCs = () => setShowListNcs(false);

  const [info, setInfo] = useState({
    criticas: 0,
    baixas: 0,
    tratadas: 0,
    encerradas: 0,
  });

  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const year = String(currentDate.getFullYear());

  const formattedDate = `${day}/${month}/${year}`;

  const optionsPie = {
    title: 'Tratativas por operador',
    sliceVisibilityThreshold: 0,
  };

  const optionsPieNCs = {
    title: 'Itens de segurança / Não Conformes (sem recorrência)',
    sliceVisibilityThreshold: 0,
  };

  const [dataPie, setDataPie] = useState([
    ['Operador', 'Quantidade de tratativas'],
  ]);
  const [dataBar, setDataBar] = useState([
    ['Tipo', 'Urgentes', 'Críticas', 'Baixas'],
  ]);

  const optionsCombo = {
    title: 'Total de NCs tratadas | últimos 3 meses',
    vAxis: { title: 'NCs' },
    hAxis: { title: 'Mês' },
    seriesType: 'bars',
    series: {
      0: { color: '#dc3545' },
      1: { color: '#ff9900' },
      2: { color: '#1a8754' },
    },
    legend: {
      position: 'bottom',
    },
  };

  useEffect(() => {
    utils.manageSidebar('close');

    const fetchData = async () => {
      setLoading(true);

      const configureDataPie = async () => {
        const res = await getQuantTratativasOp({});
        if (res.data) {
          const newDataPie = res.data.map((element) => [
            element.operator_name,
            Number(element.treatment_count),
          ]);
          setDataPie([['Operador', 'Quantidade de tratativas'], ...newDataPie]);
        }
      };

      const configureDataBar = async () => {
        const res = await getCountTratativas();
        if (res.data) {
          const newDataBar = res.data.map((element) => [
            element.data_tratativa,
            Number(element.tUrgente),
            Number(element.tAlta),
            Number(element.tBaixa),
          ]);
          setDataBar([
            ['Tipo', 'Urgentes', 'Críticas', 'Baixas'],
            ...newDataBar,
          ]);
        }
      };

      const configureInfo = async () => {
        const res = await getSupervisaoMaintenance({});
        if (res.data) {
          setInfo(res.data);
        }
      };

      const getOpenNCsOrgGroupSys = async () => {
        const res = await getGroupSystemMaintenanceOpen();
        if (res && res.data && Array.isArray(res.data)) {
          const newDataPie = res.data.map((item) => [
            item.system_type_name + ' (' + parseInt(item.count) + ')',
            parseInt(item.count),
          ]);
          newDataPie.unshift(['Item', 'Qtd NCs abertas por Item de segurança']);
          setDataPieNCs(newDataPie);
        }
      };

      await configureDataPie();
      await configureDataBar();
      await configureInfo();
      await getOpenNCsOrgGroupSys();

      setLoading(false);
    };

    fetchData();

    const interval = setInterval(fetchData, 60000);
    return () => clearInterval(interval);
  }, [setDataPie, setDataBar, setInfo]);

  return (
    <>
      <main id="main" className="main">
        <section className="section">
          <div className="col-12">
            <div className="card">
              <div className="card-body m-2">
                {loading ? (
                  <div className="col-12 text-center mt-3">
                    <div
                      className="spinner-border spinner-border-lg text-secondary"
                      role="status"
                    >
                      <span className="visually-hidden"></span>
                    </div>
                    <p className="mt-2">Carregando ...</p>
                  </div>
                ) : (
                  <>
                    <div className="position-relative">
                      <h1 className="text-center p-3 font-weigh-bold">
                        PAINEL DE SUPERVISÃO
                      </h1>
                      <div className="position-absolute top-50 end-0 translate-middle-y">
                        <button
                          type="button"
                          title="Lista NCs abertas"
                          className="btn btn-sm btn-warning me-2"
                          onClick={() => setShowListNcs(true)}
                        >
                          <i className="bi bi-list-columns-reverse"></i>
                        </button>
                        <button
                          type="button"
                          title="Relatório gerencial"
                          className="btn btn-sm btn-primary"
                          onClick={() => setShow(true)}
                        >
                          <i className="bi bi-bar-chart-line-fill"></i>
                        </button>
                      </div>
                    </div>
                    <div className="row">
                      <h4 className="text-center font-weigh-bold">
                        {formattedDate}
                      </h4>
                    </div>
                    <div className="row d-flex justify-content-around">
                      <div className="col-sm-12 col-md-2 col-lg-2">
                        <div className="card">
                          <div className="card-body bg-NCs-urgents">
                            <div className="card-title text-center">
                              <i className="bi bi-list-columns-reverse supervision"></i>
                              <h2 className="mt-4">
                                <b>{info.urgentes}</b>
                              </h2>
                              <h5>
                                <b>NCs urgentes</b>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-2 col-lg-2">
                        <div className="card">
                          <div className="card-body bg-NCs-criticals">
                            <div className="card-title text-center">
                              <i className="bi bi-list-columns-reverse supervision"></i>
                              <h2 className="mt-4">
                                <b>{info.criticas}</b>
                              </h2>
                              <h5>
                                <b>NCs críticas</b>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-2 col-lg-2">
                        <div className="card">
                          <div className="card-body bg-NCs">
                            <div className="card-title text-center">
                              <i className="bi bi-list-columns-reverse supervision"></i>
                              <h2 className="mt-4">
                                <b>{info.baixas}</b>
                              </h2>
                              <h5>
                                <b>NCs baixas</b>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-3 col-lg-3">
                        <div className="card">
                          <div className="card-body bg-NCs-day">
                            <div className="card-title text-center">
                              <i className="bi bi-calendar-event-fill"></i>
                              <h2 className="mt-4">
                                <b>{info.tratadas}</b>
                              </h2>
                              <h5>
                                <b>NCs tratadas/dia</b>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-3 col-lg-3">
                        <div className="card">
                          <div className="card-body bg-NCs-day">
                            <div className="card-title text-center">
                              <i className="bi bi-calendar2-check-fill"></i>
                              <h2 className="mt-4">
                                <b>{info.encerradas}</b>
                              </h2>
                              <h5>
                                <b>NCs encerradas/dia</b>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-5">
                      <div className="col-6">
                        <Chart
                          chartType="PieChart"
                          data={dataPie}
                          options={optionsPie}
                          width={'100%'}
                          height={'400px'}
                        />
                      </div>
                      <div className="col-6">
                        <Chart
                          chartType="PieChart"
                          data={dataPieNCs}
                          options={optionsPieNCs}
                          width={'100%'}
                          height={'400px'}
                        />
                      </div>
                    </div>
                    <div className="row mt-5">
                      <div className="col-12 d-flex">
                        <Chart
                          chartType="ComboChart"
                          data={dataBar}
                          options={optionsCombo}
                          width={'100%'}
                          height={'400px'}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
        <SupervisionModal
          show={show}
          handleClose={handleClose}
          initialInfo={info}
          optionsPie={optionsPie}
          initialDataPie={dataPie}
          dataPieNCsGeneral={dataPieNCs}
        />
        <OpenedNCsModal
          show={showListNCs}
          handleClose={handleCloseListNCs}
          date={formattedDate}
        />
      </main>
    </>
  );
}
